<div class="wrapper">
  <div #indicator class="indicator">
    <div class="spinner" [ngClass]="{ activate: isRefreshArmed }">
      <div class="item bar1"></div>
      <div class="item bar2"></div>
      <div class="item bar3"></div>
      <div class="item bar4"></div>
      <div class="item bar5"></div>
      <div class="item bar6"></div>
      <div class="item bar7"></div>
      <div class="item bar8"></div>
      <div class="item bar9"></div>
      <div class="item bar10"></div>
      <div class="item bar11"></div>
      <div class="item bar12"></div>
    </div>
  </div>
  <div class="content">
    <ng-content></ng-content>
  </div>
</div>
